import { OperationsAnalyticsPanel } from './OperationsAnalyticsPanel'
import { useOperationsAnalytics } from './useOperationsAnalytics'

/**
 * `/insights/dashboards/operations` (IB-282 View 4) — thin composition root wiring
 * `useOperationsAnalytics` (the real state) into `OperationsAnalyticsPanel` (the presentational
 * grid), mirroring `JurisdictionAnalyticsContainer`/`PortfolioAnalyticsContainer`'s own one-line
 * wire-up shape kept as its own file so this route's own diff in `AppRouter.tsx` stays a one-line
 * addition.
 */
export function OperationsAnalyticsContainer() {
  const analytics = useOperationsAnalytics()
  return <OperationsAnalyticsPanel {...analytics} />
}
